import React        from 'react'

const Content = props => {
    return (
        <div className="services-container-content">
            { props.children }
        </div>
    )
}

export default Content
